import { decodeHTML } from 'entities';
import { convert } from 'html-to-text';

/** Tags on (nearly) every article; useless for picking related news. */
export const GENERIC_NEWS_TAGS = new Set([
  'electric vehicles',
  'ev',
  'evs',
  'news',
]);

/**
 * News articles carry their tags as a "Tags: A, B, C" paragraph at the top of
 * the WordPress content (the `articles` post type has no tag taxonomy).
 */
export const extractArticleTags = (htmlContent: string): string[] => {
  const text = convert(htmlContent, { wordwrap: false });
  const match = text.match(/^\s*Tags:\s*(.+)$/m);
  if (!match) return [];
  return Array.from(
    new Set(
      match[1]
        .split(',')
        .map((tag) => decodeHTML(tag).trim())
        .filter(Boolean)
    )
  );
};

/** "Jeep Recon" -> "jeep-recon" (used by /news/tag/[slug]). */
export const slugifyTag = (tag: string): string =>
  tag
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getTagHref = (tag: string): string =>
  `/news/tag/${slugifyTag(tag)}`;

/** "jeep-recon" -> "jeep recon" (WordPress full-text search term). */
export const tagSlugToSearchTerm = (slug: string): string =>
  slug.replace(/-+/g, ' ').trim();
